import { render } from "./ItemEditCategories.vue?vue&type=template&id=79b59624&scoped=true&bindings={\"categories\":\"props\",\"itemLan\":\"props\",\"listedCategories\":\"data\",\"confirmCategoryDelete\":\"data\",\"locationsDbCategories\":\"options\",\"customCategories\":\"options\",\"categorySelectCategories\":\"options\",\"hasCategory\":\"options\",\"addCategory\":\"options\",\"removeCategory\":\"options\"}"
import script from "./ItemEditCategories.vue?vue&type=script&lang=js"
export * from "./ItemEditCategories.vue?vue&type=script&lang=js"

import "./ItemEditCategories.vue?vue&type=style&index=0&id=79b59624&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79b59624"

export default script